/* eslint-disable */

const EditLocationFields = {
  accessTo: {
    defaultValue: '',
    modal: false,
    validate: {
      names: ['notEmpty'],
    },
    prettyName: 'Access To',
    tooltip: 'Read-only. Access To value is synced from Salesforce.',
    displayComponent: 'DisplayRowSelectViewOnly',
    isDisplayBoolean: false,
    selectOptions: {
      Public: 'Public',
      Private: 'Private',
    },
  },
  address: {
    defaultValue: '',
    modal: false,
    prettyName: 'Address',
    tooltip: 'Read-only. Address value is synced from Salesforce.',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowAddressViewOnly',
  },
  aprivaDeviceAddress: {
    defaultValue: '',
    modal: false,
    prettyName: 'Campus Card',
    displayComponent: 'DisplayRowAprivaDeviceAddress',
    isDisplayBoolean: false,
    isTrueFalse: false,
  },
  covid19: {
    defaultValue: '',
    modal: false,
    prettyName: 'Covid screen Enabled?',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowSelect',
    isDisplayBoolean: true,
    isTrueFalse: true,
    selectOptions: {
      false: 'No',
      true: 'Yes',
    },
  },
  directions: {
    defaultValue: '',
    modal: false,
    prettyName: 'Directions',
    tooltip: 'Read-only. Directions value is synced from Salesforce.',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowStringViewOnly',
  },
  fridgeModel: {
    defaultValue: '',
    modal: false,
    prettyName: 'Fridge Model',
    tooltip: 'Read-only. Fridge Model value is synced from Salesforce.',
    displayComponent: 'DisplayRowStringViewOnly',
  },
  fridgeSchema: {
    defaultValue: '',
    modal: false,
    prettyName: 'Fridge Schema',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowSearch',
    isDisplayBoolean: false,
    isTrueFalse: false,
    selectOptions: {},
  },
  hostname: {
    defaultValue: '',
    modal: false,
    prettyName: 'Host Name',
    displayComponent: 'value',
  },
  hours: {
    defaultValue: '',
    modal: false,
    prettyName: 'Hours',
    displayComponent: 'DisplayRowHours',
  },

  holidayScreenEnabled: {
    defaultValue: '',
    modal: false,
    prettyName: 'Holiday screen Enabled?',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowSelect',
    isDisplayBoolean: true,
    isTrueFalse: true,
    selectOptions: {
      false: 'No',
      true: 'Yes',
    },
  },
  holidayScreenFridgeSpecific: {
    defaultValue: '',
    modal: false,
    prettyName: 'Holiday screen-Fridge specific?',
    validate: {
      names: ['notEmpty', 'integer'],
      max: 1,
      min: 0,
    },
    displayComponent: 'DisplayRowSelect',
    isDisplayBoolean: true,
    isTrueFalse: true,
    selectOptions: {
      0: 'No',
      1: 'Yes',
    },
  },
  holidayScreenStartDate: {
    defaultValue: '',
    modal: false,
    prettyName: 'Holiday Screen Start Date',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowDate',
  },
  holidayScreenEndDate: {
    defaultValue: '',
    modal: false,
    prettyName: 'Holiday Screen End Date',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowDate',
  },
  ip: {
    defaultValue: '',
    prettyName: 'IP Address',
    validate: {
      names: ['notEmpty', 'validIP'],
    },
    displayComponent: 'DisplayRowString',
  },
  latitude: {
    defaultValue: '',
    modal: false,
    prettyName: 'Latitude',
    tooltip: 'Read-only. Latitude value is synced from Salesforce.',
    validate: {
      names: ['notEmpty', 'decimal'],
      max: 49,
      min: 28,
    },
    displayComponent: 'DisplayRowNumberViewOnly',
  },
  layoutName: {
    defaultValue: '',
    modal: false,
    prettyName: 'Layout Name',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowSearch',
    isDisplayBoolean: false,
    isTrueFalse: false,
    selectOptions: {},
    hasLayoutDetails: true,
  },
  longitude: {
    defaultValue: '',
    modal: false,
    prettyName: 'Longitude',
    tooltip: 'Read-only. Longitude value is synced from Salesforce.',
    validate: {
      names: ['notEmpty', 'decimal'],
      max: -67,
      min: -128,
    },
    displayComponent: 'DisplayRowNumberViewOnly',
  },
  onlineDate: {
    defaultValue: '',
    modal: false,
    prettyName: 'Online Date',
    tooltip: 'Read-only. Online Date value is synced from Salesforce.',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowDateViewOnly',
  },
  paymentGateway: {
    defaultValue: 'authnet',
    prettyName: 'Payment Gateway',
    displayComponent: 'DisplayRowSelect',
    selectOptions: {
      freedompay_with_fcc: 'New FreedomPay card reader',
      freedompay: 'Old FreedomPay card reader',
      subsidized: 'Fully subsidized fridge',
      authnet: 'Standard experience',
    },
  },
  percentage: {
    defaultValue: '',
    modal: false,
    prettyName: 'Percentage',
    validate: {
      names: ['notEmpty', 'decimal'],
      max: 100,
      min: 0,
    },
    displayComponent: 'DisplayRowNumber',
  },
  prettyName: {
    defaultValue: '',
    modal: false,
    prettyName: 'Pretty Name',
    tooltip: 'Read-only. Pretty Name value is synced from Salesforce.',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowStringViewOnly',
  },
  priceMapTemplate: {
    defaultValue: '',
    modal: false,
    prettyName: 'Price Map Template',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowSearch',
    isDisplayBoolean: false,
    isTrueFalse: false,
    selectOptions: {},
  },
  prod: {
    defaultValue: '',
    modal: false,
    prettyName: 'Ready for Allocation',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowAllocation',
  },
  publicStatus: {
    defaultValue: '',
    modal: false,
    prettyName: 'Public Status',
    tooltip: 'Read-only. Public Status value is synced from Salesforce.',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowSelectViewOnly',
    isDisplayBoolean: false,
    isTrueFalse: false,
    selectOptions: {
      LIVE: 'LIVE',
      OFFLINE: 'OFFLINE',
    },
  },
  reserve: {
    defaultValue: '',
    modal: false,
    prettyName: 'Reserve',
    tooltip: 'Read-only. Reserve value is synced from Salesforce.',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowSelectWithReasonViewOnly',
    isDisplayBoolean: true,
    isTrueFalse: false,
    selectOptions: {
      false: 'No',
      true: 'Yes',
    },
    reasonsToChange: [
      'Always on for new fridge',
      'Connectivity issues resolved',
      'Connectivity issues',
      "Customer doesn't want to be listed in the app or on the website",
      'Customer requested to turn off',
      'Customer requested to turn on ',
    ],
  },
  route: {
    defaultValue: '',
    modal: false,
    prettyName: 'Route',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowString',
  },
  serialPort: {
    defaultValue: '',
    prettyName: 'Serial Port',
    displayComponent: 'DisplayRowSelect',
    selectOptions: {
      ttyS0: 'ttyS0',
      ttyS1: 'ttyS1',
      ttyUSB0: 'ttyUSB0',
    },
  },
  status: {
    defaultValue: '',
    prettyName: 'Status',
    validate: {
      names: ['notEmpty'],
    },
    displayComponent: 'DisplayRowSelect',
    selectOptions: {
      LIVE: 'LIVE',
      OFFLINE: 'OFFLINE',
    },
  },
  stockingSchedule: {
    defaultValue: {},
    modal: false,
    prettyName: 'Stocking Schedule',
    displayComponent: 'DisplayRowStockingSchedule',
  },
  stockingStatus: {
    defaultValue: '',
    modal: false,
    prettyName: 'Stocking Status',
    tooltip: 'Read-only. Stocking Status value is synced from Salesforce.',
    displayComponent: 'DisplayRowStringViewOnly',
  },
  stop: {
    defaultValue: '',
    modal: false,
    prettyName: 'Stop',
    validate: {
      names: ['notEmpty', 'integer'],
      max: 1000,
      min: 0,
    },
    displayComponent: 'DisplayRowNumber',
  },
  taxRate: {
    defaultValue: '',
    modal: false,
    prettyName: 'Tax Rate',
    tooltip: 'Read-only. Tax Rate value is synced from Salesforce.',
    validate: {
      names: ['notEmpty', 'decimal'],
      max: 30,
      min: 0,
    },
    displayComponent: 'DisplayRowNumberViewOnly',
  },

  timeZone: {
    defaultValue: 'Central',
    modal: false,
    validate: {
      names: ['notEmpty'],
    },
    prettyName: 'Time Zone',
    tooltip: 'Read-only. Time Zone value is synced from Salesforce.',
    displayComponent: 'DisplayRowSelectViewOnly',
    isDisplayBoolean: false,
    selectOptions: {
      NEWYORK: 'Eastern',
      CHICAGO: 'Central',
      INDIANAPOLIS: 'Indianapolis',
      LOSANGELES: 'Pacific',
      DENVER: 'Mountain',
    },
  },
  vertical: {
    defaultValue: '',
    modal: false,
    validate: {
      names: ['notEmpty'],
    },
    prettyName: 'Vertical',
    tooltip: 'Read-only. Vertical value is synced from Salesforce.',
    displayComponent: 'DisplayRowSelectViewOnly',
    isDisplayBoolean: false,
    isTrueFalse: false,
    selectOptions: {
      Office: 'Office',
      'B&I': 'B&I',
      Education: 'Education',
      Retail: 'Retail',
      'Travel/Leisure': 'Travel/Leisure',
      Healthcare: 'Healthcare',
      Airport: 'Airport',
      Testing: 'Testing',
      Marketing: 'Marketing',
      'Residential Property': 'Residential Property',
      Other: 'Other',
    },
  },
};

export { EditLocationFields };
